import { Box, Stack } from '@mui/material';
import { useActionCreators, useStateSelector } from 'shared/store';
import { ManagerUrlParamsFilter } from 'entities/filters/manager-url-params-filter';
import { useSearchParams } from 'react-router-dom';
import { Period } from 'entities/period-picker/types';
import { CashFlowPeriodPicker } from 'entities/reports/cash-flow/cash-flow-period/cash-flow-period-picker';
import { useCashFlowList } from 'entities/reports/cash-flow/cash-flow.hook';
import { CashFlowGrid } from 'entities/reports/cash-flow/cash-flow-grid';
import { BankAccountUrlParamsFilter } from 'entities/filters/bank-account-url-params-filter';
import { setPeriodActions } from 'entities/reports/cash-flow/cash-flow-period/cash-flow-period.slice';
import { CashflowUrlParamsFilter } from 'entities/filters/cashflow-url-params-filter';

export const CashFlow = () => {
  const selectedPeriod = useStateSelector((state) => state.cashFlowSelectedPeriod.value);
  const { setPeriod } = useActionCreators(setPeriodActions);
  const onSelect = (period: Period) => {
    setPeriod(period);
  };

  const [searchParams] = useSearchParams();

  const yearParam = searchParams.get('year');
  const monthParam = searchParams.get('month');
  const initialYear = Number(yearParam);

  const currentDate = initialYear === 0 ? new Date() : null;
  const year = currentDate ? currentDate.getFullYear() : initialYear;
  const month = currentDate ? currentDate.getMonth() : monthParam === null ? undefined : Number(monthParam);
  const managerId = Number(searchParams.get('managerId'));
  const bankAccountId = Number(searchParams.get('bankAccountId'));
  const cashflowId = Number(searchParams.get('cashflowId'));
  const period = yearParam ? { year, month: monthParam === null ? -1 : Number(monthParam) } : selectedPeriod;

  const { collection, isLoading, error } = useCashFlowList({ year, month, managerId, bankAccountId, cashflowId });
  return (
    <>
      <Stack sx={{ gap: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', minWidth: '600px', flexWrap: 'wrap', '& .MuiInputBase-root': { backgroundColor: '#fff' } }}>
        <Box sx={{ minWidth: 200, maxWidth: 308, mb: 1 }}>
          <CashFlowPeriodPicker 
            withQueryParams={true}
            selectedPeriod={period}
            onSelect={onSelect}
          />
        </Box>
        <Box sx={{ minWidth: 200, maxWidth: 308, mb: 1 }}>
          <BankAccountUrlParamsFilter queryParamName={'bankAccountId'} withNonSelect={false} label={'Расчётный счёт'}/>
        </Box>
        <Box sx={{ minWidth: 200, maxWidth: 308, mb: 1 }}>
          <ManagerUrlParamsFilter queryParamName={'managerId'} withNonSelect={false} label={'Менеджер'}/>
        </Box>
        <Box sx={{ minWidth: 320, maxWidth: 480, mb: 1 }}>
          <CashflowUrlParamsFilter queryParamName={'cashflowId'} label={'Статья движения денежных средств'} />
        </Box>
      </Stack>
      <CashFlowGrid collection={collection} isLoading={isLoading} error={error}/>
    </>
  );
};
